import { AnyAction, Reducer } from 'redux';
import {
    GET_UNIT_BY_ID_FAILURE,
    GET_UNIT_BY_ID_REQUEST,
    GET_UNIT_BY_ID_SUCCESS,
    GET_APPOINTMENTS_BY_ID_FAILURE,
    GET_APPOINTMENTS_BY_ID_REQUEST,
    GET_APPOINTMENTS_BY_ID_SUCCESS,
    RESET_APPOINTMENTS,
} from '../constants/unitById.constant';

const initialState = {
    loading: false,
    data: [],
    error: '',
    appointments: [],
};

const unitByIdReducer: Reducer = (state = initialState, action: AnyAction) => {
    switch (action.type) {
        case GET_UNIT_BY_ID_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case GET_UNIT_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };
        case GET_UNIT_BY_ID_FAILURE:
            return {
                loading: false,
                data: [],
                error: action.payload,
            };

        // Appointments
        case GET_APPOINTMENTS_BY_ID_REQUEST:
            return {
                ...state,
                loading: true,
                appointments: [],
            };
        case GET_APPOINTMENTS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                appointments: action.payload,
                error: '',
            };
        case GET_APPOINTMENTS_BY_ID_FAILURE:
            return {
                loading: false,
                appointments: [],
                error: action.payload,
            };
        case RESET_APPOINTMENTS:
            return {
                ...state,
                loading: false,
                appointments: [],
                error: '',
            }
        default:
            return state;
    }
};

export default unitByIdReducer;
